import Cookies from "js-cookie";
import {routes, useFetchSettings, usePostSettings} from "../routes/api";
import React, {Fragment, useEffect, useState} from "react";
import {Card, CardContent, CardHeader, Dialog, Divider, Grid, IconButton, Typography} from "@mui/material";
import ErrorDisplay from "./errorDisplay";
import DeviceSettingsField from "./deviceSettingsField";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function DeviceSettings({open, setOpen, route, deviceId, image, imageSize}) {
    const token = Cookies.get('token');
    const permissions = Cookies.get('permissions') ?
        JSON.parse(Cookies.get('permissions')).unit :
        {create: false, edit: false, delete: false, view: false};
    const webAdmin = Cookies.get('webAdmin') === 'T';
    const deviceRoute = routes[String(route).toLowerCase()];

    const [data, setData] = useState({});
    const [unavailable, setUnavailable] = useState(false);
    const [edit, setEdit] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [alert, setAlert] = useState(false);
    const [notAligned, setNotAligned] = useState(false);

    const {
        data: detail,
        statusCode: fetchStatus,
        loading,
        handleCall: handleFetch
    } = useFetchSettings(token, deviceRoute, deviceId);

    const {
        data: postResp,
        statusCode: postStatus,
        handleCall: handlePost
    } = usePostSettings(token, deviceRoute, deviceId);


    const handleSubmit = () => {
        handlePost({body: editedData});
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await handleFetch();
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        if (open) {
            fetchData();
        }
    }, [open]);

    useEffect(() => {
        if (postStatus === 504) {
            setAlert(true);
        } else if (postStatus >= 200 && postStatus < 300) {
            setAlert(false);
            setEditedData(postResp);
            setData(postResp);
        } else if (postStatus > 300) {
            setAlert(true);
        }
    }, [postStatus, postResp]);


    useEffect(() => {
        if (fetchStatus === 504) {
            setAlert(false);
            setUnavailable(true);
        } else if (fetchStatus >= 200 && fetchStatus < 300) {
            setAlert(false);
            setEditedData(detail);
            setData(detail);
        } else if (fetchStatus > 300) {
            setAlert(true);
        }
    }, [fetchStatus, detail]);

    if (unavailable) return <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperComponent={Card}
        aria-labelledby="popup-dialog-title"
        aria-describedby="popup-dialog-description"
        fullWidth
        maxWidth='xs'
    >
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 5,
                mb: 8
            }}
        >
            <Typography variant='h6'>
                {route} Settings Unavailable
            </Typography>
        </Box>
    </Dialog>


    return <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperComponent={Card}
        aria-labelledby="popup-dialog-title"
        aria-describedby="popup-dialog-description"
        fullWidth
        maxWidth='lg'
    >
        <CardHeader
            variant='h5'
            action={(permissions.edit || webAdmin) ?
                <IconButton onClick={() => (setEdit(!edit))}>
                    <EditIcon/>
                </IconButton> :
                null
            }
            title={`${route} Settings`}/>
        <CardContent
            sx={{
                minWidth: '270px',
                minHeight: '50px',
                overflow: 'visible',
                ml: 3
            }}>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mt: 5,
                        mb: 5
                    }}
                >
                    <CircularProgress/>
                </Box> :
                <Grid container
                      spacing={1}
                      columnSpacing={3}
                      sx={{margin: 'auto', mb: 2}}
                      alignItems="flex-start"
                      justifyContent="center"
                >
                    {data.system_ver &&
                        <Grid size={12} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Typography variant="overline">
                                System Version: {data.system_ver}
                            </Typography>
                        </Grid>}
                    <Grid size={12} key='error-display'>
                        <ErrorDisplay
                            alert={alert}
                            setAlert={setAlert}
                            response={postResp}
                            statusCode={postStatus}
                            account
                        />
                    </Grid>
                    <Grid size={12}>
                        <Divider variant='middle'/>
                    </Grid>
                    {Object.entries(editedData).map(([key, fieldData]) => (
                        <Fragment key={key}>
                            <DeviceSettingsField
                                inputData={fieldData}
                                fieldData={edit ? fieldData : data[key]}
                                setEditField={setEditedData}
                                alias={key}
                                disabled={!edit}
                                image={image}
                                imageSize={imageSize}
                                setNotAligned={setNotAligned}
                            />
                            <Grid size={12} sx={{mt: 0.5, mb: 0.5}}>
                                <Divider variant='middle'/>
                            </Grid>
                        </Fragment>
                    ))
                    }
                    <Grid size={12} key='submit'>
                        {edit && <Button
                            component="label"
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={JSON.stringify(data) === JSON.stringify(editedData) || notAligned}
                            sx={{margin: 2}}>
                            Save
                        </Button>}
                    </Grid>
                </Grid>
            }
        </CardContent>
    </Dialog>
}